var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM13.0344 6.25644C12.9252 6.18037 12.7902 6.15095 12.6593 6.17469C12.5284 6.19843 12.4123 6.27338 12.3368 6.38294L9.38566 10.6654L7.56363 8.99105C7.46575 8.90111 7.33609 8.85384 7.20329 8.8597C7.07049 8.86555 6.94549 8.92405 6.85591 9.02226L6.29726 9.63471C6.11159 9.83826 6.12557 10.1536 6.32851 10.34L9.27313 13.0435C9.37974 13.1414 9.52355 13.1883 9.66737 13.1721C9.81119 13.1558 9.94093 13.0781 10.023 12.9589L13.8373 7.42207C13.9933 7.19553 13.9371 6.88547 13.7114 6.7282L13.0344 6.25644Z",
    fill: "#003B6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/Subtract.0a11d96f11c43e3aafdc98438efd79f6.svg";
export { ForwardRef as ReactComponent };